export const getCartClubQuantity = (cartQuantity) =>
  [24, 12].find((quantity) => cartQuantity >= quantity)

export const getClubCanCount = (items) =>
  Object.entries(items).reduce((arr, [sku, item]) => arr + item.quantity, 0)
